import {VisuallyHidden} from '@radix-ui/react-visually-hidden';
import cn from 'classnames';
import React from 'react';

import InlineProgress from '@/components/InlineProgress/InlineProgress';
import {AUTO_DELIVERY_PROGRESS_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import {getFormattedAriaLabel} from '@/services/accessibilityService';
import {getLocalizedStrings} from '@/services/localization/localizationService';
import {twx} from '@/utils/tailwindUtils';

const AutoDeliveryProgress = ({className, progressClassName, progress, progressLabel, steps}) => {
    if (!steps?.length) return;
    const localizedStrings = getLocalizedStrings();
    const isSingleStep = steps.length === 1;
    const progressAriaLabel = getFormattedAriaLabel(AUTO_DELIVERY_PROGRESS_ARIA_LABEL, localizedStrings[progressLabel]);

    return (
        <div className={twx('text-14 tracking-04 md:text-16', className)}>
            <InlineProgress className='bg-primary-dark-30' progressClassName={progressClassName} progress={progress} />
            <div className={cn('mt-2 flex gap-2 text-center', isSingleStep ? 'justify-center' : 'justify-between')}>
                {steps.map((step, i) => (
                    <span
                        className={cn(
                            'flex-1 truncate',
                            !isSingleStep && {
                                'text-start': i === 0,
                                'text-end': i === steps.length - 1,
                            }
                        )}
                        key={i}
                    >
                        {step === progressLabel && <VisuallyHidden>{progressAriaLabel}</VisuallyHidden>}
                        <span aria-hidden='true'>{localizedStrings[step]}</span>
                    </span>
                ))}
            </div>
        </div>
    );
};

export default AutoDeliveryProgress;
